<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('goodsSku.package.BasicInformation') }}
      <template slot="right">
        <template>
          <el-button v-if="isEdit || isAdd" @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button v-if="isEdit || isAdd" @click="handleConfirm(false)">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
          <el-button v-if="!$store.getters.cusId" type="primary" @click="showLog">{{$t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
        </template>
      </template>
    </BjDivider>

    <el-form ref="form" :model="goodsData" :rules="rules" label-width="230px" class="form">
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.form.skuName')" prop="skuName">
            <BjInput v-model="goodsData.skuName" :disabled="isView" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('BusinessPurchaseOrder2.form.skuName')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="SKU" prop="skuCode">
            <BjInput v-model="skuCode2" :disabled="isView || isEdit" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>

        <BjDivider>{{ $t('goodsSku.package.packageProductMsg') }}
          <template>
            <el-button type="primary" :disabled="isView" @click="onDelete">{{ $t('goodsSku.package.delete') }}SKU</el-button>
            <el-button type="primary" :disabled="isView" @click="onAddSkuDetail">{{ $t('addText') }}SKU</el-button>
          </template>
        </BjDivider>
        <el-table ref="storeTable" :data="goodsData.skuDetailList" stripe border :header-cell-style="$rowStyle.DEFAULT" @selection-change="onSelections">
          <el-table-column align="center" type="index" :label="$t('table.countText')" width="65" />
          <el-table-column align="center" prop="itemId" type="selection" />
          <el-table-column align="center" prop="standardSkuCode" label="SKU"></el-table-column>
          <el-table-column align="center" prop="skuName" :label="$t('BusinessPurchaseOrder2.form.skuName')"></el-table-column>
          <el-table-column align="center" prop="num" :label="$t('billingPage.quantity')">
            <template slot-scope="scope">
              <BjInput v-model="scope.row.num" oninput="value=value.replace(/[^\d]/g,'')" :disabled="isView" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="action" :label="$t('operationText')" align="center">
            <template slot-scope="scope">
              <el-button type="text" :disabled="isView" @click="goodsData.skuDetailList.splice(scope.$index,1)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>

    <!-- SKU -->
    <BjDialogList ref="skuDialogList" :config="$BjDialogListConfig.skuDefault()" multiple @confirm="onConfirmSkuDialogList" />
  </div>
</template>
<script>
import {goodsApi, commonApi} from '@/api';
import viewMiXin from '@/utils/view-mixin';
import orderLog from '@/utils/log.js';

export default {
  mixins: [viewMiXin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colSpan: 8,
      goodsData: {
        id: this.$route.query.id || null,
        skuCode: '',
        skuName: '',
        costPrice: 0,
        categoryId: null,
        categoryName: '',
        salesPrice: '',
        skuDetailList: [],

        itemType: '',
        categoryIdList: [],
        barCode: '',
        vendor: '',
        buying_dep: '',
        buyingDep: '',
        buyerName: '',
        brand: '',
        cartonBoxBarcode: '',
        seasonalGoods: 'AllSeas',
        merchandiser: '',
        activityPrice: null,
        marketPrice: null,
        distributionPrice: null,
        wholesalePrice: null,
        clearingPrice: null,
        discontinued: true,
        inventoryItem: true,
        purchaseItem: true,
        salesItem: true,
        fragile: 0,
        dangerousGoods: false,
        flammable: false,
        imageUrl: '',
        skuLicenseList: [],
        length: null,
        width: null,
        height: null,
        weight: null,
        qty: null,
        cartonLength: null,
        cartonWidth: null,
        cartonHeight: null,
        cartonWeight: '',
      },
        selections: [],
      // rules: {
      //   categoryId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      //   categoryName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      //   skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      //   skuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      //   standardSkuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      //   salesPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      // },
      skuCode2: null
    };
  },
  computed: {
    itemType() {
      if (this.isAdd) {
        return this.goodsData.skuDetailList.reduce((pre, item) => {
          pre += item.costPrice * item.num;
          return pre;
        }, 0);
      }
      return 0;
    },
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.skuCode2) {
            callback(new Error(this.$t('inputText')));
          }
          callback();
        });
      };

      return {
        categoryId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        categoryName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        standardSkuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        salesPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuCode: [{ required: true, validator: validateFullAddress, trigger: 'blur' }],
      };
    },
  },
  watch: {
    itemType(val) {
      if (this.isAdd) {
        this.goodsData.costPrice = val;
      }
    }
  },
  created() {
    if (this.isEdit || this.isView) {
      this.getGoodsDetailData();
    }
  },
  methods: {
    showLog() {
        orderLog(
            this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
                actionApi: commonApi.getLogPages,
                defaultQuery: {
                  id: this.$route.query.id
                },
                columns: [
                  {
                      prop: 'creationDate',
                      label: 'BjDialogListConfig.Operationtime',
                  },
                  {
                      prop: 'createdName',
                      label: 'BjDialogListConfig.Operator',
                  },
                  {
                      prop: 'remark',
                      label: 'BjDialogListConfig.Remarks',
                  },
                ],
            }),
        );
    },
    changeCategory(item) {
      if (!item?.label) return;
      this.goodsData.categoryName = item.label;
    },
    async getGoodsDetailData() {
      this.goodsData = await goodsApi.detailSku({id: this.$route.query.id});
      this.skuCode2 = this.goodsData.standardSkuCode || this.goodsData.skuCode;
    },
    onConfirmSkuDialogList(data) {
      if (this.goodsData.skuDetailList.length > 0) {
        const dataList = data.filter(item => !this.goodsData.skuDetailList.some(v => v.skuCode === item.skuCode)).map(item => {
          return {...item, num: null};
        });
        this.goodsData.skuDetailList = [...this.goodsData.skuDetailList, ...dataList];
      } else {
        this.goodsData.skuDetailList = data.map(item => {
          return {...item, num: null};
        });
      }
    },
    onAddSkuDetail() {
      this.$refs.skuDialogList.show();
    },
    onDelete() {
      if (this.selections.length) {
        this.goodsData.skuDetailList = this.goodsData.skuDetailList.filter(item => this.selections.indexOf(item) === -1);
        this.goodsData.selections = [];
      } else {
        this.msgError(this.$t('ThreePartySalesOrder.selectDataWarning'));
      }
    },
    onSelections(val) {
      this.selections = val;
    },
    submitApi(flag){
      let obj = null;
      if (this.isEdit) {
            const finalList = this.goodsData.skuDetailList.map(item => {
              return {
                num: item.num ? Number(item.num) : 1,
                skuCode: item.skuCode,
                packageskuId: item.id
              };
            });
            obj = {
                // ...this.goodsData,
                id: this.goodsData.id,
                skuCode: this.skuCode2,
                skuName: this.goodsData.skuName,
                skuDetailList: finalList,
            };
            goodsApi.updateSkulist(obj).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
               setTimeout(() => {
                this.complete('CSGGoodsSkuPackageIndex');
               }, 500);
              }
            });
      } else {
        if (!this.goodsData.skuDetailList.length > 0) {
          this.msgError(this.$t('goodsSku.package.msgErrorText'));
          return false;
        }
        const finalList = this.goodsData.skuDetailList.map(item => {
          return {
            num: item.num ? Number(item.num) : 1,
            packageSkuId: item.id,
            id: null,
            skuId: item.id
          };
        });
          obj = {
            ...this.goodsData,
          skuCode: this.skuCode2,
          skuName: this.goodsData.skuName,
          costPrice: this.goodsData.costPrice,
          salesPrice: this.goodsData.salesPrice,
          skuDetailList: finalList,
        };
          goodsApi.addSku({
          flag,
          setFlag: 1, // 0-单品，1-套餐
          skuList: [obj]
        }).then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.goodsData = {
              ...this.goodsData,
              skuCode: '',
              skuName: '',
              costPrice: 0,
              categoryId: null,
              categoryName: '',
              salesPrice: '',
              skuDetailList: [],
            };
            setTimeout(() => {
              this.complete('CSGGoodsSkuPackageIndex');
            }, 500);
          }
        });
      }
    },
    // 页面保存（新增、编辑）
    handleConfirm(flag) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let bstop = true
          this.goodsData.skuDetailList.forEach(item=>{
            if(!item.num || item.num == 0){
              bstop = false
            }
          })
          if (!bstop || !this.goodsData.skuDetailList.length > 0) return this.msgError(this.$t('goodsSku.package.msgErrorText'));
          const total = this.goodsData.skuDetailList.reduce((pre, cur) => (pre += Number(cur.num)), 0);
          if(total == 1) return this.$confirm(this.$t('goodsSku.package.msgErrorText2'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(()=>{
            this.submitApi(flag)
          })
          this.submitApi(flag)
        }
      });
    },
  },
};
</script>
<style>
</style>
